/**
 * Presentation helpers for PC Performance metrics.
 */

export function formatMs(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "—";
  }
  const ms = Number(value);
  if (ms < 1000) {
    return `${Math.round(ms)} ms`;
  }
  if (ms < 60_000) {
    return `${(ms / 1000).toFixed(1)} s`;
  }
  const minutes = Math.floor(ms / 60_000);
  const seconds = Math.round((ms % 60_000) / 1000);

  return `${minutes}m ${seconds}s`;
}

export function formatNumber(value, digits = 1) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "—";
  }

  return Number(value).toLocaleString(undefined, {
    maximumFractionDigits: digits,
  });
}

export function boundLabel(bound) {
  if (!bound) {
    return "unknown";
  }

  return String(bound).replace(/-/g, " ");
}

export function formatTimestamp(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "—";
  }

  return new Date(Number(value)).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
